module.exports = __webpack_public_path__ + "media/images/dot_grid_dark-6b049085d136a66cadc8865290401049.png";